import { api } from "@/lib/orgApi";

export const CPT_SYSTEM = "http://www.ama-assn.org/go/cpt";

export async function listCptCodes({ q, active, category } = {}) {
  const params = {};
  if (q) params.q = q;
  if (active != null) params.active = active;
  if (category) params.category = category;
  const { data } = await api.get("/cpt", { params });
  return data;
}

export async function getCptCode(code) {
  const { data } = await api.get(`/cpt/${encodeURIComponent(code)}`);
  return data;
}
